import Recorder from './Recorder';
import { VIDEO_FPS } from '../data/Config';

class AsyncRecorder extends Recorder {
  canvas: HTMLCanvasElement;
  framesNumber: number;
  duration: number;
  offlineFrequencies: Uint8Array[] | null;
  offlineWaveforms: Uint8Array[] | null;
  _currentFrame: number = 0;

  constructor(
    canvas: HTMLCanvasElement,
    framesNumber: number,
    duration: number,
    offlineFrequencies: Uint8Array[] | null,
    offlineWaveforms: Uint8Array[] | null
  ) {
    super();

    this.canvas = canvas;
    this.framesNumber = framesNumber;
    this.duration = duration;
    this.offlineFrequencies = offlineFrequencies;
    this.offlineWaveforms = offlineWaveforms;
  }
  update() {
    //
  }

  get waitingForFrames(): boolean {
    return this._currentFrame < this.framesNumber;
  }

  getPosition() {
    const p = this._currentFrame / this.framesNumber;
    return Math.max(0, Math.min(1, p));
  }

  getCurrentTime(): number {
    const duration = (this.framesNumber / VIDEO_FPS) * 1000;
    return duration * this.getPosition();
  }

  getSpectrum(): Uint8Array {
    if (this.offlineFrequencies) {
      const position = this.getPosition();
      const index = Math.round(
        (this.offlineFrequencies!.length - 1) * position
      );
      return this.offlineFrequencies![index];
    } else {
      return new Uint8Array([]);
    }
  }

  getWaveform(): Uint8Array {
    if (this.offlineWaveforms) {
      const position = this.getPosition();
      const index = Math.round((this.offlineWaveforms!.length - 1) * position);
      return this.offlineWaveforms![index];
    } else {
      return new Uint8Array([]);
    }
  }
}

export default AsyncRecorder;



// WEBPACK FOOTER //
// ./src/video/AsyncRecorder.ts